import request from '@/utils/request'

export function updateCardCfg(data) {
  return request({
    url: 'api/v1/card-info/updateCardCfg',
    method: 'post',
    data: data
  })
}

export function getCardCfgList(data) {
  return request({
    url: 'api/v1/card-info/getCardCfg',
    method: 'post',
    data: data
  })
}

export function getCardCfgAllList(data) {
  return request({
    url: 'api/v1/card-info/getCardCfgAll',
    method: 'post',
    data: data
  })
}

export function exportCardCfg() {
  return request({
    url: 'api/v1/card-info/export',
    method: 'get' })
}

export function importCardCfg(data) {
  return request({
    url: 'api/v1/card-info/import',
    method: 'post',
    data: data
  })
}

export function delCardCfg(data) {
  return request({
    url: 'api/v1/card-info/delCardCfg',
    method: 'delete',
    data: data
  })
}
